class CustomVenue extends HTMLElement {
  constructor() {
    super()
    this.select = this.querySelector('select')
    this.customWatercolorPrice = this.querySelector('#CustomVenuePrice')
    this.select.addEventListener('change', this.handleChange.bind(this))
  }

  connectedCallback() {
    this.value = this.getValue()
    this.getProductData()
  }

  handleChange() {
    this.value = this.getValue()
    this.getProductData()
    if (this.value === 'custom') {
      this.updatePrice()
      this.toggleBuyButtonPrice()
    } else {
      this.toggleBuyButtonPrice('remove')
      this.clearPrice()
    }
  }

  updatePrice() {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    this.customWatercolorPrice.textContent = `(+${formatter.format((this.productData.price) / 100).replace('.00', '')})`
  }

  clearPrice() {
    this.customWatercolorPrice.textContent = ``
  }

  toggleBuyButtonPrice(event = 'add') {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    if (event === 'add') {
      document.querySelectorAll('#price_buy').forEach(btn => {
        const price = parseInt(btn.textContent.replace(/\,/g, '').replace(/\$/g,'') * 100)
        btn.textContent = `${formatter.format((price + this.productData.price) / 100).replace('.00', '')}`
      })
    } else {
      document.querySelectorAll('#price_buy').forEach(btn => {
        const price = parseInt(btn.textContent.replace(/\,/g, '').replace(/\$/g,'') * 100)
        btn.textContent = `${formatter.format((price - this.productData.price) / 100).replace('.00', '')}`
      })
    }
  }

  getValue() {
    return this.select.value
  }

  getProductData() {
    this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.productData
  }
}

customElements.define('custom-venue', CustomVenue)
